<template>
  <div class="top_box">
    <div class="banner">
      <div class="title">{{ bannerMessage.title }}</div>
      <div class="line"></div>
      <div class="content">{{ bannerMessage.subtitle }}</div>
      <img :src="bannerMessage.thumbUrl" alt="" />
    </div>
    <div class="main_box">
      <div class="menu_box">
        <div class="left_menu">
          <div class="left_title">
            <div class="title1">新闻中心</div>
            <div class="title2">NEWS CENTER</div>
          </div>
          <div class="left_item">
            <div
              class="item"
              v-for="(item, index) in menuList"
              :key="'item' + index"
              :class="{ choose: item.key === pushValue.classifyId }"
              @click="changeItem(item.key)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="right_article" v-show="!ifShowDetail">
          <el-input
            class="top_input"
            v-model="pushValue.title"
            placeholder="输入关键词"
            @keyup.enter="searchList"
            clearable
            @clear="clearInput"
          >
            <template #append>
              <el-icon style="font-size: 28px" @click="searchList"
                ><Search
              /></el-icon>
            </template>
          </el-input>
          <template v-if="backValue.length > 0">
            <div class="card_box" v-if="backValue && backValue.length > 0">
              <div
                class="pre_card"
                :class="{ has: backValue[item - 1] }"
                v-for="item in 3"
                :key="'card' + item"
                @click="chooseItem(backValue[item - 1])"
              >
                <template v-if="backValue[item - 1]">
                  <div class="top_img">
                    <img
                      :src="
                        backValue[item - 1].thumbUrl ||
                        require(`@/assets/text/default${item - 1}.jpg`)
                      "
                    />
                  </div>
                  <div class="bottom_box">
                    <div class="top_time">
                      {{ backValue[item - 1].timeline }}
                    </div>
                    <div class="article_title">
                      {{ backValue[item - 1].title }}
                    </div>
                    <!-- <div class="article">
                    {{ item.intro }}
                  </div> -->
                    <div class="bottom_btn">更多 >>></div>
                  </div>
                </template>
              </div>
            </div>

            <div class="card_line">
              <div
                class="card_item"
                v-for="(item, index) in backValue.slice(3, 11)"
                :key="'list_card' + index"
                @click="chooseItem(item)"
              >
                <div class="time_box">
                  <img
                    :src="
                      item.thumbUrl ||
                      require(`@/assets/text/default${index}.jpg`)
                    "
                    alt=""
                  />
                </div>
                <!-- <div class="line_middle"></div> -->
                <div class="article_box">
                  <div class="article_title">
                    {{ item.title }}
                  </div>
                  <!-- <div class="article">
                    {{ item.intro }}
                  </div> -->
                </div>
                <div class="right_pic">
                  {{ item.timeline.substring(0, 10) }}
                </div>
              </div>
            </div>

            <div class="page_box">
              <el-pagination
                :key="paginationKey"
                background
                layout="prev, pager, next"
                :total="total"
                @current-change="handleCurrentChange"
              />
            </div>
          </template>
          <div class="no_box" v-else>
            <img src="@/assets/text/nopicDe.png" alt="" />
            <div class="default_text">暂无数据</div>
          </div>
        </div>

        <div class="right_article2" v-if="ifShowDetail">
          <div class="small_title">
            <span
              @click="
                () => {
                  ifShowDetail = false;
                }
              "
              >返回</span
            >
          </div>
          <div class="article_box">
            <div class="title">
              {{ nowItem.title
              }}<span v-if="nowItem.link" @click="turnToLink(nowItem)"
                ><img src="@/assets/text/link.png" alt=""
              /></span>
            </div>
            <!-- <img :src="nowItem.thumbUrl" alt="" /> -->
            <div class="time_style">发布时间：{{ nowItem.timeline }}</div>
            <!-- <img
              v-if="nowItem.thumbUrl"
              :src="nowItem.thumbUrl"
              alt=""
              onerror="this.onerror=null;this.src=defaultImg()"
            /> -->
            <div
              class="article g-rich-text-wrap"
              v-html="normalizeRichText(nowItem.content)"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, watch, nextTick, onMounted } from "vue";
import api from "@/api/api";
import { normalizeRichText } from "@/utils/richText";
import { Search } from "@element-plus/icons-vue";
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();
const defaultImg = () => {
  const numbers = [1, 2, 3, 4, 5];
  const randomIndex = Math.floor(Math.random() * numbers.length);
  return require(`@/assets/text/default${numbers[randomIndex]}.jpg`);
};
let backValue = ref([]);
let nowItem = ref({});
let ifShowDetail = ref(false);
let bannerMessage = ref({});
let pushValue = reactive({
  pageNo: 1,
  pageSize: 10,
  resourceId: 68,
  classifyId: 4,
  title: "",
});
let total = ref(0);
let menuList = ref([
  {
    name: "领导关怀",
    key: 4,
  },
  {
    name: "集团要闻",
    key: 1,
  },
  {
    name: "成员动态",
    key: 2,
  },
]);
const paginationKey = ref(0);
const changeItem = (key) => {
  pushValue.classifyId = key;
  pushValue.pageNo = 1;
  ifShowDetail.value = false;
  paginationKey.value++;
  router.push({
    query: {
      id: key,
    },
  });
  // getList();
};
const getBanner = async () => {
  let res = await api.getPageConfigDetail(85);
  if (res.code === "0") {
    bannerMessage.value = res.res.data;
  }
};
getBanner();
const getList = async () => {
  let res = await api.getArticlePage(pushValue);
  if (res.code === "0") {
    total.value = res.res.data.total;
    backValue.value = res.res.data.records;
  }
};
getList();
const handleSizeChange = (val) => {
  pushValue.pageNo = val;
  getList();
};
const chooseItem = (item) => {
  if (item.link) {
    window.open(item.link, "_blank");
  } else {
    ifShowDetail.value = true;
    nowItem.value = item;
    window.scrollTo({
      top: 427,
      behavior: "smooth",
    });
  }
};
const turnToLink = (item) => {
  window.open(item.link, "_blank");
};
const handleCurrentChange = (val) => {
  pushValue.pageNo = val;
  nextTick(() => {
    getList();
  });
};
const searchList = () => {
  pushValue.pageNo = 1;
  // 重置分页
  paginationKey.value++;
  getList();
};
const clearInput = () => {
  getList();
};
watch(
  () => route,
  (newval) => {
    console.log("newval", newval);
    if (newval && newval.query.id) {
      pushValue.classifyId = newval.query.id * 1;
      ifShowDetail.value = false;
      nextTick(() => {
        getList();
      });
    }
    if (newval && newval.query.content) {
      api.getById({ id: newval.query.content }).then((res) => {
        if (res.code === "0") {
          ifShowDetail.value = true;
          nowItem.value.content = res.res.data.content;
          nowItem.value.title = res.res.data.title;
          nowItem.value.timeline = res.res.data.timeline;
          nowItem.value.link = res.res.data.link;
        }
      });
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
  { deep: true, immediate: true }
);
</script>
<style lang="less" scoped>
:deep(.el-input-group__append) {
  background-color: #ffffff;
  cursor: pointer;
}
:deep(.el-input__wrapper) {
  box-shadow: 1px 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
}
:deep(span) {
  // font-family: inherit !important;
  // font-size: inherit !important;
  // text-indent: inherit !important;
  // line-height: inherit !important;
  // color: inherit !important;
}
:deep(p) {
  // font-family: inherit !important;
  // font-size: inherit !important;
  // text-indent: inherit !important;
  // line-height: inherit !important;
  // color: inherit !important;
}
.no_box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .default_text {
    margin-top: 21px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #317eb2;
    line-height: 22px;
  }
  img {
    width: 291px;
    height: 209px;
  }
}
.time_style {
  color: #666;
  font-size: 14px;
  font-family: "微软雅黑", "Microsoft Yahei", "Arial";
  margin-bottom: 15px;
  text-align: center;
}
.card_line {
  .card_item {
    width: 100%;
    height: 100px;
    background: #fafafa;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    transition: transform 0.3s ease;
    cursor: pointer;
    .time_box {
      width: 154px;
      height: 100%;
      padding: 8px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 138px;
        height: 85px;
      }
      // .top {
      //   font-family: LucidaGrande;
      //   font-size: 35px;
      //   color: #808080;
      //   line-height: 41px;
      //   font-style: normal;
      // }
      // .bottom {
      //   font-family: LucidaGrande;
      //   font-size: 16px;
      //   color: #9c9c9c;
      //   line-height: 19px;
      //   font-style: normal;
      // }
    }
    .line_middle {
      width: 1px;
      height: 80px;
      background: #d1d1d1;
    }
    .article_box {
      flex: 1;
      padding: 0px 30px;
      .article_title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #333333;
        line-height: 25px;
        text-align: left;
        font-style: normal;
        margin-bottom: 9px;
      }
      .article {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #969696;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .right_pic {
      padding-right: 37px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #969696;
      text-align: left;
      font-style: normal;
    }
  }

  .card_item:hover {
    box-shadow: 0px 0px 17px 0px rgba(176, 176, 176, 0.5);
    .right_pic {
      color: #006ab1 !important;
    }
    .article_box {
      .article_title {
        color: #006ab1 !important;
      }
    }
    .line_middle {
      display: none;
    }
  }
}
.page_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 96px;
}
.card_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 37px 0px 47px 0px;
  box-sizing: border-box;
  .pre_card {
    width: 421px;
    max-width: 30%;
    &.has {
      overflow: hidden;
      position: relative;
      // width: 21.93vw;
      // height: 24.0625vw;
      height: 366px;
      box-sizing: border-box;
      // width: 421px;
      // height: 462px;
      background: #ffffff;
      border: 1px solid #dadada;
      transition: transform 0.3s ease;
      cursor: pointer;
      .top_img {
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: auto;
          height: 140%;
          transition: transform 0.3s ease;
        }
        width: 100%;
        height: 204px;
      }
      .bottom_box {
        padding: 0px 25px;
        box-sizing: border-box;
        .top_time {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #bcbdbe;
          // line-height: 20px;
          text-align: left;
          font-style: normal;
          margin: 10px 0px;
        }
        .article_title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #333333;
          text-align: left;
          font-style: normal;
          margin-bottom: 10px;
          line-height: 1.5;
          height: 3em;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .article {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #969696;
          line-height: 20px;
          text-align: justify;
          font-style: normal;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
        .bottom_btn {
          position: absolute;
          bottom: 22px;
          left: 25px;
          width: 103px;
          height: 25px;
          border-radius: 13px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #969696;
          border: 1px solid #b0b0b0;
          line-height: 25px;
          text-align: center;
          font-style: normal;
          cursor: pointer;
        }
      }
    }
  }
  .pre_card:hover {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
    .top_img {
      img {
        transform: scale(1.1);
      }
    }
    .bottom_box {
      .article_title {
        color: #006ab1 !important;
      }
      .bottom_btn {
        border: none !important;
        background: #006ab1 !important;
        color: #ffffff !important;
      }
    }
  }
}
.top_input {
  width: 666px;
  height: 70px;
  background: #ffffff;
}
.top_box {
  width: 100%;
  .banner {
    width: 100%;
    height: 427px;
    position: relative;
    .title {
      position: absolute;
      left: 170px;
      top: 120px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #ffffff;
    }
    .line {
      position: absolute;
      left: 170px;
      top: 223px;
      width: 60px;
      height: 2px;
      background: rgba(255, 255, 255, 0.4);
    }
    .content {
      position: absolute;
      left: 170px;
      top: 254px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #ffffff;
    }
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: -1;
    }
  }
  .main_box {
    width: 100%;
    // 底部留白用固定值：原来 14.82vh 会让窗口越高留白越多（2000 高的窗口就是 296px）
    padding: 42px 8.33vw;
    box-sizing: border-box;
    .menu_box {
      display: flex;
      .left_menu {
        height: 226px;
        width: 180px;
        background: #f0f0f0;
        margin-right: 63px;
        z-index: 3;
        .left_title {
          width: 100%;
          height: 74px;
          background: #006ab1;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: center;
          .title1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
            margin-right: 17px;
          }
          .title2 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            margin-right: 17px;
            margin-top: 4px;
          }
        }
        .left_item {
          .item {
            cursor: pointer;
            text-align: right;
            height: 37px;
            line-height: 37px;
            padding-right: 17px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
          }
          .choose {
            background: #223e62 !important;
            color: #ffffff !important;
          }
        }
      }
      .right_article {
        // z-index: 3;
        width: calc(100% - 243px);
      }
      .right_article2 {
        width: calc(100% - 243px);
        box-sizing: border-box;
        .small_title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 14px;
          color: #999999;
          line-height: 20px;
          text-align: left;
          font-style: normal;
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 14px;
            color: #999999;
            line-height: 20px;
            font-style: normal;
            cursor: pointer;
          }
        }

        .article_box {
          .title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 48px;
            color: #333333;
            line-height: 67px;
            font-style: normal;
            text-align: center;
            margin: 35px 0px 42px 0px;
            span {
              img {
                width: 38px;
                height: 38px;
                margin-left: 30px;
                cursor: pointer;
              }
            }
          }
          img {
            width: 100%;
            height: auto;
          }
          .article {
            // font-family: 仿宋_GB2312;
            // font-weight: 600;
            // font-size: 16px;
            // color: #333333;
            // line-height: 30px;
            // text-align: left;
            // font-style: normal;
            // margin-top: 36px;
            // padding-bottom: 36px;
            table {
              border-collapse: collapse; /* 使得单元格之间的边框合并为单一边框 */
            }

            table,
            th,
            td {
              border: 1px solid black; /* 设置边框宽度为3像素 */
            }
          }
          .detail_list {
            div {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 16px;
              color: #333333;
              line-height: 30px;
              text-align: left;
              font-style: normal;
            }
          }
        }
      }
    }
  }
}
</style>
